<template>
  <div>
    <!--<div v-if="showHelloPlane" class="flightInfo">-->
      <!--<h2> -->
        <!--<svg version="1.0" xmlns="http://www.w3.org/2000/svg"-->
         <!--width="25.000000pt" height="25.000000pt" viewBox="0 0 1280.000000 1280.000000"-->
         <!--preserveAspectRatio="xMidYMid meet">-->
          <!--<g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"-->
          <!--fill="#fff" stroke="none">-->
          <!--<path d="M1095 12789 c-148 -27 -217 -43 -285 -66 -319 -109 -583 -359 -711-->
          <!---674 -36 -88 -56 -163 -80 -304 -18 -107 -19 -249 -19 -5345 0 -5096 1 -5238-->
          <!--19 -5345 39 -227 83 -346 186 -506 127 -196 325 -360 546 -450 88 -36 163 -56-->
          <!--304 -80 107 -18 249 -19 5345 -19 5096 0 5238 1 5345 19 141 24 216 44 304 80-->
          <!--221 90 419 254 546 450 103 160 147 279 186 506 18 107 19 249 19 5345 0 5096-->
          <!---1 5238 -19 5345 -24 141 -44 216 -80 304 -90 221 -254 419 -450 546 -160 103-->
          <!---279 147 -506 186 -107 18 -247 19 -5355 18 -3064 -1 -5266 -5 -5295 -10z-->
          <!--m10639 -654 c193 -50 351 -208 401 -401 13 -52 15 -633 15 -5334 0 -4701 -2-->
          <!---5282 -15 -5334 -50 -193 -208 -351 -401 -401 -52 -13 -633 -15 -5334 -15-->
          <!---4701 0 -5282 2 -5334 15 -193 50 -351 208 -401 401 -13 52 -15 633 -15 5334-->
          <!--0 4701 2 5282 15 5334 50 191 207 349 396 400 47 13 761 15 5334 15 4707 1-->
          <!--5287 -1 5339 -14z"/>-->
          <!--<path d="M5306 9084 c-4 -1039 -11 -1893 -15 -1897 -5 -4 -338 94 -742 219-->
          <!---404 125 -984 304 -1289 398 l-555 171 -240 477 c-132 262 -245 482 -251 488-->
          <!---12 12 -956 291 -962 285 -2 -2 1 -99 7 -217 12 -230 39 -756 71 -1393 35-->
          <!---698 38 -747 44 -753 7 -6 9014 -2804 9183 -2852 467 -133 840 56 969 490 29-->
          <!--101 27 319 -4 420 -73 229 -211 385 -435 490 -54 25 -675 218 -1800 558 -945-->
          <!--286 -1721 523 -1725 526 -4 5 -614 2607 -986 4208 l-27 116 -82 11 c-133 19-->
          <!---1019 130 -1089 137 l-65 6 -7 -1888z"/>-->
          <!--<path d="M5221 5220 c-110 -23 -212 -103 -263 -208 -31 -62 -33 -74 -33 -167-->
          <!--0 -88 3 -107 27 -157 137 -293 548 -299 690 -10 31 62 33 74 33 167 0 87 -3-->
          <!--107 -26 155 -76 161 -259 255 -428 220z"/>-->
          <!--<path d="M6119 4977 c-65 -19 -129 -58 -178 -112 -188 -204 -97 -545 166 -621-->
          <!--82 -24 202 -16 275 18 74 34 152 112 186 186 24 50 27 69 27 157 0 89 -3 107-->
          <!---29 162 -35 76 -113 154 -192 190 -67 30 -185 40 -255 20z"/>-->
          <!--<path d="M1407 2553 c-4 -3 -7 -174 -7 -380 l0 -373 5000 0 5000 0 -2 378 -3-->
          <!--377 -4991 3 c-2745 1 -4994 -1 -4997 -5z"/>-->
          <!--</g>-->
        <!--</svg> -->
        <!--Flight Information-->
      <!--</h2>-->
    <!--</div>-->
    <!--<HelloPlane v-if="showHelloPlane" />-->
    <RotateWorld v-if="showHelloPlane" />
    <div v-bind:class="{ overlay: showHelloPlane, admin: !showHelloPlane }" >
      <h3>Now Boarding</h3>
      <h2>{{nowBoardingPassenger.name}} at Gate {{nowBoardingPassenger.gate}}</h2>
    </div>
  </div>
</template>

<style scoped lang="scss">
svg{
  display: inline-block;
}
.flightInfo{
  position: absolute;
  z-index: 2;
  top: 50px;
  left: 350px;
  h2{
    font-size: 40px;
    color: white;
  -webkit-text-stroke-width: .5px;
  -webkit-text-stroke-color: black;
  }
}
.admin{
  margin: 30px;
}
.overlay{
  top: 440px;
  left: 300px;
  /*position: absolute;*/
  background: rgba(0,0,0,.8);
  color: white;
  padding: 15px;
  border-radius: 10px;
  z-index: 2;
  margin-bottom: 30px;
  h2{
    font-size: 35px;
  }
  h3{
    border-bottom: 1px dotted white;
    width: 100%;
    display: block;
    font-size: 25px;
  }
}
</style>

<script>
import axios from 'axios';
//import HelloPlane from '../components/HelloPlane.vue';
import RotateWorld from '../components/RotateWorld.vue';

export default {
  name: "NowBoarding",
  
  components: { 
    //HelloPlane
    RotateWorld
  },
  data: () => ({
    nowBoardingPassenger: '',
    timer: '',
  }),
  props: ['showHelloPlane'],
  methods: {
    async getNowBoardingPassenger(){
      const thePassenger = await axios.get(`${this.$store.state.baseAPI}/api/writefile/nowBoarding`);
      this.nowBoardingPassenger = thePassenger.data;
    },
    cancelAutoUpdate () { clearInterval(this.timer); }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  created () {
      this.getNowBoardingPassenger();
      this.timer = setInterval(this.getNowBoardingPassenger, 2000)
  },
}

</script>
